import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { DisciplinaPage } from '../pages/disciplina.page';

const DisciplinaRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/disciplina' element={<DisciplinaPage />} />
    </Routes>
  );
};

export { DisciplinaRoutes };
